import React, { useState } from 'react'
import MarkdownWrapper from '../../utils/markdown-wrapper'

import { ReactComponent as TopTear } from '../../../assets/svgs/top-tear.svg'
import { ReactComponent as BottomTear } from '../../../assets/svgs/bottom-tear.svg'

const MailingListSignup = ({ content }) => {
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [showThankYou, setShowThankYou] = useState(false)
    const [showError, setShowError] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        setShowError(false)
        setErrorMsg('')
        if (email.trim() === '' || firstName.trim() === '' || lastName.trim() === '') {
            setErrorMsg('Please fill in all fields.')
            setShowError(true)
            return
        }

        const formData = {
            email: email.trim(),
            first_name: firstName.trim(),
            last_name: lastName.trim(),
            group_id: content.groupId
        }

        fetch(`${process.env.REACT_APP_API_URL}/mailing-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.status !== '200') {
                    setErrorMsg(data.data)
                    setShowError(true)
                    return
                }
                let dataLayer = window.dataLayer || []
                dataLayer.push({
                    event: 'FormSubmission',
                    formType: 'SignUp',
                    formID: 'StayInTouch'
                })
                setEmail('')
                setShowThankYou(true)
            })
            .catch((error) => {
                console.error('Error:', error)
            })
    }

    return (
        <div className="content-band wysiwyg mailing-list-signup">
            <div className="top-tear">
                <TopTear />
            </div>
            <div className="container">
                { content?.title && <h2>{content.title}</h2> }
                { content?.description && <MarkdownWrapper content={content.description} /> }
                { showThankYou
                    ? <p>{content.successMessage}</p>
                    : <form className="form" onSubmit={handleSubmit}>
                        <div className="two-col-form">
                            <div className="form-group ">
                                <label htmlFor="first_name">First Name</label>
                                <input
                                    type="text"
                                    id="first_name"
                                    name="first_name"
                                    className="form-control"
                                    placeholder="Joy"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    required />
                            </div>
                            <div className="form-group">
                                <label htmlFor="last_name">Last Name</label>
                                <input
                                    type="text"
                                    id="last_name"
                                    name="last_name"
                                    className="form-control"
                                    placeholder="Justice"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    required />
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                className="form-control"
                                placeholder="joyjustice@example.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required />
                        </div>
                        {showError && <p className="invalid-feedback">{errorMsg}</p>}
                        <button type="submit" className="btn small ">
                            {content.buttonLabel ? content.buttonLabel : 'Submit'}
                        </button>
                    </form>
                }
            </div>
            <div className="bottom-tear">
                <BottomTear />
            </div>
        </div>
    )
}

export default MailingListSignup
